"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toPascalCase = exports.toCamelCase = exports.toKebabCase = exports.toSnakeCase = exports.iterableToArray = exports.asyncIterableToArray = void 0;

var _assert = require("./assert");

var _is = require("./is");

var _toTypeString = require("./to-type-string");

const asyncIterableToArray = async asyncIterable => {
  (0, _assert.assert)(asyncIterable, _is.isAsyncIterable, actual => `"asyncIterableToArray" expects first argument to be an AsyncIterable, but was given "${(0, _toTypeString.toTypeString)(actual)}"`);
  const iterator = asyncIterable[Symbol.asyncIterator]();
  let item = await iterator.next();
  const items = [];

  while (item.done !== true) {
    items.push(item.value);
    item = await iterator.next();
  }

  return items;
};

exports.asyncIterableToArray = asyncIterableToArray;

const iterableToArray = iterable => {
  (0, _assert.assert)(iterable, _is.isIterable, actual => `"iterableToArray" expects first argument to be an Iterable, but was given "${(0, _toTypeString.toTypeString)(actual)}"`);
  return (0, _is.isArray)(iterable) ? iterable : Array.from(iterable);
};

exports.iterableToArray = iterableToArray;

const toSnakeCase = str => {
  var _str$match;

  return (_str$match = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) === null || _str$match === void 0 ? void 0 : _str$match.map(x => x.toLocaleLowerCase()).join('_');
};

exports.toSnakeCase = toSnakeCase;

const toKebabCase = str => {
  var _str$match2;

  return (_str$match2 = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) === null || _str$match2 === void 0 ? void 0 : _str$match2.map(x => x.toLocaleLowerCase()).join('-');
};

exports.toKebabCase = toKebabCase;

const toCamelCase = str => {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, char) => char.toUpperCase());
};

exports.toCamelCase = toCamelCase;

const toPascalCase = str => {
  return str.replace(/\w\S*/g, m => m.charAt(0).toUpperCase() + m.substr(1).toLowerCase());
};

exports.toPascalCase = toPascalCase;